export const DRAW_INSURANCE_TYPE = "insurance";
export const SOFT_COST_DRAW_TYPE = "soft costs";
export const HARD_COST_DRAW_TYPE = "hard costs";
export const HARD_AND_SOFT_COST_DRAW_TYPE = "hard & soft costs";
export const SOFT_COST_CATEGORY_ID = 1;


export const DRAW_SUB_TYPES = {
  SOFT_COST: {
    label: 'Soft Costs',
    value: 'soft costs',
  },
  HARD_COST: {
    label: 'Hard Costs',
    value: 'hard costs',
  },
  HARD_AND_SOFT_COST: {
    label: 'Hard & Soft Costs',
    value: 'hard & soft costs',
  }
}